<!-- <div class="container-fluid" style="min-height: 70vh ;"> -->
  <div class="container-fluid pt-4" style="min-height: calc(100vh - 220px);">

  <div class="row mb-3">
    <div class="col-xl-12">
      <button class="btn mb-1 btn-pill ms-2" [ngClass]="selectedSetting=='hourlyRate'?'btn-primary':'btn-light'"
        (click)="selectedSetting!='hourlyRate'?selectedSetting='hourlyRate':selectedSetting=''"
        *ngIf="modules.includes('billing')">
        <i class="fa-solid fa-clock"></i>
        {{"hourlyRate" | translate}}</button>
      <button class="btn mb-1 btn-pill ms-2" [ngClass]="selectedSetting=='userManagement'?'btn-primary':'btn-light'"
      (click)="selectedSetting!='userManagement'?selectedSetting='userManagement':selectedSetting=''"
      *ngIf="modules.includes('users')">
        <i class="fa-solid fa-users"></i>
        {{"userManagement" | translate}}</button>

      <button class="btn mb-1 btn-pill ms-2" [ngClass]="selectedSetting=='energyPrice'?'btn-primary':'btn-light'"
      (click)="selectedSetting!='energyPrice'?selectedSetting='energyPrice':selectedSetting=''"
      *ngIf="modules.includes('electricity')"> <i class="fa-solid fa-hand-holding-dollar"></i>
      {{"energyPrice" | translate}}</button>


      <button class="btn mb-1 btn-pill ms-2" [ngClass]="selectedSetting=='power'?'btn-primary':'btn-light'"
        (click)="selectedSetting!='power'?selectedSetting='power':selectedSetting=''"
        *ngIf="modules.includes('modulator')"><i class="fas fa-fw fa-bolt"></i>
        {{"installation" | translate}}</button>
      <button class="btn mb-1 btn-pill ms-2" [ngClass]="selectedSetting=='connectivity'?'btn-primary':'btn-light'"
        (click)="selectedSetting!='connectivity'?selectedSetting='connectivity':selectedSetting=''"
        *ngIf="modules.includes('network') || modules.includes('wifi')">
        <i class="fas fa-fw fa-broadcast-tower"></i> {{"connectivity" | translate}}
      </button>
      <button class="btn mb-1 btn-pill ms-2" [ngClass]="selectedSetting=='password'?'btn-primary':'btn-light'"
        (click)="selectedSetting!='password'?selectedSetting='password':selectedSetting=''"
        *ngIf="modules.includes('network')"><i class="fas fa-fw fa-key"></i> {{"password" | translate}}</button>
      <button class="btn mb-1 btn-pill ms-2" [ngClass]="selectedSetting=='wifi'?'btn-primary':'btn-light'"
        (click)="selectedSetting!='wifi'?selectedSetting='wifi':selectedSetting=''"
        *ngIf="modules.includes('network') || modules.includes('wifi')"><i class="fas fa-fw fa-wifi"></i>
        {{"wifi" | translate}}</button>
      <button class="btn mb-1 btn-pill ms-2" [ngClass]="selectedSetting=='ethernet'?'btn-primary':'btn-light'"
        (click)="selectedSetting!='ethernet'?selectedSetting='ethernet':selectedSetting=''"
        *ngIf="modules.includes('network')"><i class="fas fa-fw fa-ethernet"></i>
        {{"ethernetTitle" | translate}}</button>
      <button class="btn mb-1 btn-pill ms-2" [ngClass]="selectedSetting=='ocpp'?'btn-primary':'btn-light'"
        (click)="selectedSetting!='ocpp'?selectedSetting='ocpp':selectedSetting=''" *ngIf="modules.includes('ocpp')"><i
          class="fas fa-fw fa-cogs"></i>
        {{"OCPP" | translate}}</button>
        <button class="btn mb-1 btn-pill ms-2" [ngClass]="selectedSetting=='mqtt_user'?'btn-primary':'btn-light'"
          (click)="selectedSetting!='mqtt_user'?selectedSetting='mqtt_user':selectedSetting=''" *ngIf="modules.includes('mqtt_user')">
          <i class="fas fa-rss-square"></i> {{"MQTT" | translate}}
      </button>
      <button class="btn mb-1 btn-pill ms-2" [ngClass]="selectedSetting=='scheduler'?'btn-primary':'btn-light'"
        (click)="selectedSetting!='scheduler'?selectedSetting='scheduler':selectedSetting=''"
        *ngIf="modules.includes('schedman')"><i class="fas fa-clock pe-1"></i>{{"scheduler" |
        translate}}</button>
      <button class="btn mb-1 btn-pill ms-2" [ngClass]="selectedSetting=='power-scheduler'?'btn-primary':'btn-light'"
        (click)="selectedSetting!='power-scheduler'?selectedSetting='power-scheduler':selectedSetting=''"
        *ngIf="modules.includes('schedman') && !serial.includes('CTM')"><i class="fas fa-tachometer-alt pe-1"></i> {{"powerScheduler" |
        translate}}</button>
      <button class="btn mb-1 btn-pill ms-2" [ngClass]="selectedSetting=='rfid'?'btn-primary':'btn-light'"
        (click)="selectedSetting!='rfid'?selectedSetting='rfid':selectedSetting=''" *ngIf="modules.includes('rfid')"><i
          class="fas fa-fw fa-hand-pointer"></i> {{"RFID-mode" | translate}}</button>

      <button class="btn mb-1 btn-pill ms-2" [ngClass]="selectedSetting=='geolocation'?'btn-primary':'btn-light'"
        (click)="selectedSetting!='geolocation'?selectedSetting='geolocation':selectedSetting=''"  *ngIf="modules.includes('geolocation') && deviceSubType !=='astro_lum'">
        <i class="fas fa-map-marked-alt"></i> {{"geoLocationTabTitle" | translate}}
      </button>
      <button class="btn mb-1 btn-pill ms-2" [ngClass]="selectedSetting=='fwupdate'?'btn-primary':'btn-light'"
        (click)="selectedSetting!='fwupdate'?selectedSetting='fwupdate':selectedSetting=''"
        *ngIf="modules.includes('fwupd') || modules.includes('fw_update')">
        <i class="fas fa-cloud-download-alt"></i> {{"FWUpdate" | translate}}</button>
        <button class="btn mb-1 btn-pill ms-2" [ngClass]="selectedSetting=='name'?'btn-primary':'btn-light'"
        (click)="selectedSetting!='name'?selectedSetting='name':selectedSetting=''"
       > <i class="fa fa-address-card"></i> {{ 'deviceName' |translate}}</button>
      <button class="btn mb-1 btn-pill ms-2" [ngClass]="selectedSetting=='reset'?'btn-primary':'btn-light'"
        (click)="selectedSetting!='reset'?selectedSetting='reset':selectedSetting=''">
        <i class="fas fa-power-off"></i> {{"reset" | translate}}
      </button>
      <button class="btn mb-1 btn-pill ms-2" [ngClass]="selectedSetting=='chargVinc'?'btn-primary':'btn-light'"
        (click)="selectedSetting!='chargVinc'?selectedSetting='chargVinc':selectedSetting=''" >
        <i class="fas fa-link"></i> {{"chgVincTab" | translate}}</button>

      <button *ngIf="modules.includes('device')" class="btn mb-1 btn-pill ms-2" [ngClass]="selectedSetting=='ancDeviceSettings'?'btn-primary':'btn-light'"
        (click)="selectedSetting!='ancDeviceSettings'?selectedSetting='ancDeviceSettings':selectedSetting=''" >
        <i class="fa-solid fa-gears pe-1"></i>{{ 'ancDeviceCfgTitle' | translate }}
      </button>
      <button *ngIf="modules.includes('schedule') && showAncPrograms" class="btn mb-1 btn-pill ms-2" [ngClass]="selectedSetting=='ancPrograms'?'btn-primary':'btn-light'"
        (click)="selectedSetting!='ancPrograms'?selectedSetting='ancPrograms':selectedSetting=''" >
        <i class="fa-solid fa-calendar-days pe-1"></i>{{ 'weeklySchedule' | translate }}
      </button>
      <button *ngIf="modules.includes('scheduler') && showLumScheduler" class="btn mb-1 btn-pill ms-2" [ngClass]="selectedSetting=='lumScheduler'?'btn-primary':'btn-light'"
        (click)="selectedSetting!='lumScheduler'?selectedSetting='lumScheduler':selectedSetting=''" >
        <i class="fa-solid fa-calendar-days pe-1"></i>{{ 'weeklySchedule' | translate }}
      </button>
      <button *ngIf="modules.includes('astcal' ) && deviceSubType =='astro_lum'" class="btn mb-1 btn-pill ms-2" [ngClass]="selectedSetting=='lumAstcal'?'btn-primary':'btn-light'"
        (click)="selectedSetting!='lumAstcal'?selectedSetting='lumAstcal':selectedSetting=''" >
        <i class="fas fa-map-marked-alt pe-1"></i>{{ 'lumAstcalTitle' | translate }}
      </button>
      <button *ngIf="modules.includes('alarms')" class="btn mb-1 btn-pill ms-2" [ngClass]="selectedSetting=='alarms'?'btn-primary':'btn-light'"
        (click)="selectedSetting!='alarms'?selectedSetting='alarms':selectedSetting=''" >
        <i class="fas fa-bell pe-1"></i>{{ 'lumAlarmsTitle' | translate }}
      </button>
            <button *ngIf="modules.includes('seasons')" class="btn mb-1 btn-pill ms-2" [ngClass]="selectedSetting=='seasons'?'btn-primary':'btn-light'"
        (click)="selectedSetting!='seasons'?selectedSetting='seasons':selectedSetting=''" >
        <i class="fa-solid fa-seedling pe-1"></i>{{ 'seasons' | translate }}
      </button>
      <button *ngIf="modules.includes('nimble')" class="btn mb-1 btn-pill ms-2" [ngClass]="selectedSetting=='bluetooth'?'btn-primary':'btn-light'"
        (click)="selectedSetting!='bluetooth'?selectedSetting='bluetooth':selectedSetting=''" >
        <i class="fa-brands fa-bluetooth-b pe-1"></i>{{ 'tourDeviceBluetoothTitle' | translate }}
      </button>
      <button *ngIf="modules.includes('relays') || modules.includes('device')" class="btn mb-1 btn-pill ms-2" [ngClass]="selectedSetting=='channels'?'btn-primary':'btn-light'"
        (click)="selectedSetting!='channels'?selectedSetting='channels':selectedSetting=''" >
        <i class="fa-solid fa-toggle-on pe-1"></i>{{ 'channels' | translate }}
      </button>

      <button class="btn mb-1 btn-pill ms-2" (click)="selectedSetting=''">{{"all" | translate}}</button>
    </div>
  </div>

  <div *ngIf="loading" class="row d-flex align-items-center justify-content-center vh-50">
    <div class="col-xl-2 d-flex justify-content-center">
      <div  class="spinner-border" style="width: 8rem; height: 8rem;" role="status">
        <span class="visually-hidden">{{ 'loading' | translate }}</span>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-xl-12" *ngIf="!loading">
      <app-power  class="ps-3 pe-3" [ngClass]="(selectedSetting == '' || selectedSetting == 'power') ? '' : 'd-none'"
        *ngIf="!newInstallSectionCompatible && modules.includes('modulator')" [connectors]="connectors"
        [allSettings]="true">
      </app-power>
      <app-power-new class="ps-3 pe-3" [ngClass]="(selectedSetting == '' || selectedSetting == 'power') ? '' : 'd-none'"
        *ngIf="newInstallSectionCompatible && modules.includes('modulator')" [connectors]="connectors"
        [allSettings]="true" [solarActive]="modules.includes('solar')">
      </app-power-new>

      <!-- Fila para Hourly Rate y User Management (divididos 50/50 en pantallas grandes) -->
      <div class="row ps-3 pe-3" [ngClass]="(selectedSetting == '' || selectedSetting == 'hourlyRate' || selectedSetting == 'userManagement') ? '' : 'd-none'">
        <app-hourly-rate
          class="col-xl-6 col-lg-12"
          [ngClass]="(selectedSetting == '' || selectedSetting == 'hourlyRate') ? '' : 'd-none'"
          [allSettings]="true"
          *ngIf="modules.includes('billing')">
        </app-hourly-rate>

        <app-user-management
          class="col-xl-6 col-lg-12"
          [ngClass]="(selectedSetting == '' || selectedSetting == 'userManagement') ? '' : 'd-none'"
          [allSettings]="true"
          *ngIf="modules.includes('users')">
        </app-user-management>
      </div>



      <app-electricity-rate class="col-xl-12" [ngClass]="(selectedSetting == '' || selectedSetting == 'energyPrice') ? '' : 'd-none'" *ngIf="modules.includes('electricity')" [allSettings]="true">
      </app-electricity-rate>
      <div class="row ps-3 pe-3" [ngClass]="{'w-xl-100' : selectedSetting == '' || ['all'].includes(selectedSetting)}">

        <app-anc-programs class="col-xl-12" *ngIf="modules.includes('schedule') && showAncPrograms" [ngClass]="(selectedSetting == '' || selectedSetting == 'ancPrograms') ? '' : 'd-none'" [allSettings]="true"></app-anc-programs>
        <app-lum-scheduler class="col-xl-12" *ngIf="modules.includes('scheduler') && showLumScheduler" [ngClass]="(selectedSetting == '' || selectedSetting == 'lumScheduler') ? '' : 'd-none'" [allSettings]="true"></app-lum-scheduler>
        <app-lum-astcal class="col-xl-12" *ngIf="modules.includes('astcal' ) && deviceSubType =='astro_lum'" [ngClass]="(selectedSetting == '' || selectedSetting == 'lumAstcal') ? '' : 'd-none'" [allSettings]="true"></app-lum-astcal>
        <app-lum-alarms class="col-xl-12" *ngIf="modules.includes('alarms')" [ngClass]="(selectedSetting == '' || selectedSetting == 'alarms') ? '' : 'd-none'" [allSettings]="true"></app-lum-alarms>
        <app-dl-programs class="col-xl-12" *ngIf="modules.includes('schedule') && deviceSubType === 'datalog+'" [ngClass]="(selectedSetting == '' || selectedSetting == 'ancPrograms') ? '' : 'd-none'" [allSettings]="true"></app-dl-programs>
        <app-anc-device-settings class="col-xl-12" *ngIf="modules.includes('device')" [ngClass]="(selectedSetting == '' || selectedSetting == 'ancDeviceSettings') ? '' : 'd-none'" [allSettings]="true" ></app-anc-device-settings>
      <app-anc-seasons class="col-xl-6" *ngIf="modules.includes('seasons')" [ngClass]="(selectedSetting == '' || selectedSetting == 'seasons') ? '' : 'd-none'" [allSettings]="true"></app-anc-seasons>
      <app-nimble class="col-xl-6" *ngIf="modules.includes('nimble')" [ngClass]="(selectedSetting == '' || selectedSetting == 'bluetooth') ? '' : 'd-none'" [allSettings]="true"></app-nimble>
      <app-channels class="col-xl-6" *ngIf="modules.includes('relays')" [ngClass]="(selectedSetting == '' || selectedSetting == 'channels') ? '' : 'd-none'" [allSettings]="true"></app-channels>
      <app-anc-channels class="col-xl-6" *ngIf="modules.includes('device')" [ngClass]="(selectedSetting == '' || selectedSetting == 'channels') ? '' : 'd-none'" [allSettings]="true"></app-anc-channels>
      <!-- <app-anc-calendar class="col-xl-6" *ngIf="modules.includes('calendar')" [ngClass]="(selectedSetting == '' || selectedSetting == 'calendar') ? '' : 'd-none'" [allSettings]="true"></app-anc-calendar> -->

        <app-connectivity class="col-xl-6" [ngClass]="(selectedSetting == '' || selectedSetting == 'connectivity') ? '' : 'd-none'" *ngIf="modules.includes('network') || modules.includes('wifi')" [modules]="modules" [allSettings]="true">
        </app-connectivity>
        <app-password class="col-xl-6" [ngClass]="(selectedSetting == '' || selectedSetting == 'password') ? '' : 'd-none'" *ngIf="modules.includes('network')" [allSettings]="true">
        </app-password>
        <app-wifi class="col-xl-6" [ngClass]="(selectedSetting == '' || selectedSetting == 'wifi') ? '' : 'd-none'" *ngIf="modules.includes('network') || modules.includes('wifi')" [modules]="modules" [allSettings]="true">
        </app-wifi>
        <app-ethernet class="col-xl-6" [ngClass]="(selectedSetting == '' || selectedSetting == 'ethernet') ? '' : 'd-none'" *ngIf="modules.includes('network')" [allSettings]="true">
        </app-ethernet>
        <app-ocpp class="col-xl-6" [ngClass]="(selectedSetting == '' || selectedSetting == 'ocpp') ? '' : 'd-none'" *ngIf="modules.includes('ocpp')" [allSettings]="true">
        </app-ocpp>
        <app-mqtt class="col-xl-6" [ngClass]="(selectedSetting == '' || selectedSetting == 'mqtt_user') ? '' : 'd-none'" *ngIf="modules.includes('mqtt_user')" [allSettings]="true">
        </app-mqtt>
        <app-charge-scheduler class="col-xl-6" [ngClass]="(selectedSetting == '' || selectedSetting == 'scheduler') ? '' : 'd-none'" *ngIf="modules.includes('schedman')" [connectors]="connectors" [allSettings]="true">
        </app-charge-scheduler>
        <app-power-scheduler class="col-xl-6" [ngClass]="(selectedSetting == '' || selectedSetting == 'power-scheduler') ? '' : 'd-none'" *ngIf="modules.includes('schedman') && !serial.includes('CTM')" [allSettings]="true" [connectors]="connectors">
        </app-power-scheduler>
        <app-rfid class="col-xl-6" [ngClass]="(selectedSetting == '' || selectedSetting == 'rfid') ? '' : 'd-none'" *ngIf="modules.includes('rfid')" [allSettings]="true">
        </app-rfid>
        <app-geolocation class="col-xl-6" [ngClass]="(selectedSetting == '' || selectedSetting == 'geolocation') ? '' : 'd-none'" [allSettings]="true"*ngIf="modules.includes('geolocation') && deviceSubType !=='astro_lum'" >
        </app-geolocation>
        <app-fwupdate class="col-xl-6" [ngClass]="(selectedSetting == '' || selectedSetting == 'fwupdate') ? '' : 'd-none'" *ngIf="modules.includes('fwupd') || modules.includes('fw_update')" [modules]="modules" [allSettings]="true">
        </app-fwupdate>
        <app-name class="col-xl-6"  [ngClass]="(selectedSetting == '' || selectedSetting == 'name') ? '' : 'd-none'"  [allSettings]="true"></app-name>
        <app-reset class="col-xl-6" [ngClass]="(selectedSetting == '' || selectedSetting == 'reset') ? '' : 'd-none'" [allSettings]="true">
        </app-reset>
      </div>
      <app-linkage class="col-xl-8" [ngClass]="(selectedSetting == '' || selectedSetting == 'chargVinc') ? '' : 'd-none'"  [allSettings]="true"></app-linkage>


    </div>
  </div>
</div>

<!-- Modal de Error -->
<div class="modal fade" [class.show]="showErrorModal" [style.display]="showErrorModal ? 'block' : 'none'"
     [class.d-block]="showErrorModal" tabindex="-1" role="dialog" aria-labelledby="errorModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <!-- <div class="modal-header bg-danger text-white">
        <h5 class="modal-title" id="errorModalLabel">
          <i class="fas fa-exclamation-triangle me-2"></i>
          Error de Conexión
        </h5>
      </div> -->
      <div class="modal-body text-center">
        <div class="mb-3">
          <i class="fas fa-times-circle text-danger" style="font-size: 3rem;"></i>
        </div>
        <h6 class="mb-3">{{ errorMessage }}</h6>
        <p class="text-muted">Será redirigido al dashboard del dispositivo.</p>
      </div>
      <div class="modal-footer justify-content-center">
        <button type="button" class="btn btn-primary" (click)="closeErrorModal()">
          <i class="fas fa-home me-2"></i>
          Ir al Dashboard
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Backdrop del modal -->
<div class="modal-backdrop fade" [class.show]="showErrorModal" *ngIf="showErrorModal"></div>
